<template>
  <div class="tw-relative tw-flex tw-items-center">
    <svg-vue
      icon="icons/datepicker"
      class="tw-h-4 tw-w-4 tw-relative tw-left-2 tw-text-grey-light"
    />
    <input
      type="text"
      class="tw-p-2 tw-border-2 tw-rounded tw-pl-8 tw--ml-4"
      placeholder="--/--/----"
      readonly
      role="button"
      v-bind="$attrs"
    >
  </div>
</template>